(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("Lavender"), require("Lotus"));
	else if(typeof define === 'function' && define.amd)
		define("LotusMVW", ["Lavender", "Lotus"], factory);
	else if(typeof exports === 'object')
		exports["LotusMVW"] = factory(require("Lavender"), require("Lotus"));
	else
		root["LotusMVW"] = factory(root["Lavender"], root["Lotus"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_0__, __WEBPACK_EXTERNAL_MODULE_2__) {
return 


// WEBPACK FOOTER //
// webpack/universalModuleDefinition